<template>
	<div class="py-80">
		<img class="mb-3" src="@/assets/empty-state-img/empty.png" alt="img" width="150px" v-if="type==$keys.EMPTY_TYPE_1">	
		<img class="mb-0" src="@/assets/empty-state-img/user-empty.png" alt="img" width="150px" v-if="type==$keys.EMPTY_TYPE_2">	

		<p class="empty-text">
			{{message}}
		</p>
	</div>
</template>
<script type="text/javascript">
export default{
	props: {
		message: {
			type: String,
			default: "Empty",
		},
		type:{
			type: String,
			default: "type_1",
		}
	},
}
</script>
